/* eslint-disable react-hooks/exhaustive-deps */

import { TextField } from "src/components";
import Autocomplete from "src/components/Autocomplete";
import GnlKullaniciAyarDTO from "src/models/Base/Auth/GnlKullaniciAyarDTO";
import { helper } from "src/utils/helper";
import { translate } from "src/i18n/tHelper";
import { useEffect, useState } from "react";
import kullaniciAyarService from "src/services/Genel/kullanici.ayar.service";
import { useAppSelector } from "src/store";
import { useConfirmation } from "src/base/ConfirmationDialog/ConfirmationService";

interface IMailGonderimAutocompleteProps {
    value: GnlKullaniciAyarDTO[];
    label: string;
    onChange: (value: GnlKullaniciAyarDTO[]) => void;
    error?: boolean;
    helperText?: string;
    required?: boolean;
}
const MailGonderimAutocomplete = (props: IMailGonderimAutocompleteProps): JSX.Element => {
    const [options, setOptions] = useState<Array<GnlKullaniciAyarDTO>>([]);
    const userInfo = useAppSelector(s => s.userLogin.userInfo);
    const confirm = useConfirmation();

    useEffect(() => {
        (async () => {
            const res = await kullaniciAyarService.find({
                filters: {
                    groupOperator: "and",
                    predicates: [
                        {
                            fieldName: "tip",
                            operator: "=",
                            value1: 1
                        }
                    ]
                }
            });
            if (res.responseCode !== 200) {
                confirm({
                    description: res.errorMessage,
                    title: '',
                    variant: 'info',
                    catchOnCancel: false
                });
                setOptions([]);
                return;
            }
            setOptions(res.data);
        })();
    }, []);

    return (
        <Autocomplete
            fullWidth
            options={options}
            value={props.value?.length > 0 ? props.value : []}
            multiple
            freeSolo={false}
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            getOptionLabel={(option) => {
                return option?.ayar;
            }}
            filterOptions={(option, state) => {
                var filtered: GnlKullaniciAyarDTO[] = [];
                if (!state.inputValue)
                    return filtered;
                var filter = option.filter(f => helper.UpperCaseAsc(f.ayar).indexOf(helper.UpperCaseAsc(state.inputValue)) > -1)
                if (filter.length == 0) {
                    filtered.push({
                        ayar: translate("pages|hastaServis|order|mailOnTanimlari", "Ekle") + " " + state.inputValue,
                        kullaniciId: userInfo.id,
                        tip: 1
                    });
                }
                else filtered = filter;
                return filtered;
            }}
            onChange={(event, newValues) => {
                for (let i in newValues) {
                    if (!newValues[i].id) {
                        newValues[i].ayar = newValues[i].ayar?.replace(translate("pages|hastaServis|order|mailOnTanimlari", "Ekle") + " ", "")
                    }
                }
                props.onChange(newValues)
            }}
            renderInput={(params) => {
                return (
                    <TextField
                        {...params}
                        label={props.label}
                        required={props.required}
                        error={props.error}
                        helperText={props.helperText}
                    />
                )
            }}
        />
    )
}
export default MailGonderimAutocomplete;